import React, { useEffect, useRef, useState } from 'react';

const EMOJI_GROUPS = {
  자주쓰는: ['😀', '😂', '😅', '😊', '😍', '🥰', '😘', '😎', '🤔', '😢', '😭', '😡', '😱', '🥳', '👍', '👎', '🙏', '👏', '💪', '✌️'],
  하트감정: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💕', '💯', '🔥', '✨', '⭐', '🎉', '🎊', '😴', '😇', '🤗', '😉', '😜'],
  사물기타: ['📌', '📎', '✅', '❌', '⚠️', '📢', '🔔', '📝', '📚', '✏️', '☕', '🍀', '🌟', '🚀', '🎯', '👀', '💡', '🕐', '📅', '🙌'],
};

export default function EmojiTextarea({ value, onChange, placeholder, rows = 3, className, onKeyDown }) {
  const [open, setOpen] = useState(false);
  const textareaRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [open]);

  const insertEmoji = (emoji) => {
    const el = textareaRef.current;
    if (!el) {
      onChange(value + emoji);
      return;
    }
    const start = el.selectionStart ?? value.length;
    const end = el.selectionEnd ?? value.length;
    const next = value.slice(0, start) + emoji + value.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      const pos = start + emoji.length;
      el.setSelectionRange(pos, pos);
    });
  };

  return (
    <div className="emoji-textarea-wrap" ref={wrapRef}>
      <textarea
        ref={textareaRef}
        className={className}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
      <button
        type="button"
        className="emoji-toggle-btn"
        title="이모지 넣기"
        onClick={() => setOpen((v) => !v)}
      >
        😊
      </button>
      {open && (
        <div className="emoji-picker">
          {Object.entries(EMOJI_GROUPS).map(([label, list]) => (
            <div key={label} className="emoji-picker-group">
              <div className="emoji-picker-group-label">{label}</div>
              <div className="emoji-picker-grid">
                {list.map((e) => (
                  <button key={e} type="button" className="emoji-picker-item" onClick={() => insertEmoji(e)}>
                    {e}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
